import React, { Suspense, Fragment, useEffect } from "react";
import { BrowserRouter, Router, Route } from "react-router-dom";
import "./scss/style.scss";
import "antd/dist/antd.min.css";
import routes, { renderRoutes } from "./routes";
import { Routes } from "react-router-dom";
import axios from "axios";
import { NEW_API_SERVER } from "./components/Auth/AuthGuard";
import { useSelector } from "react-redux";
import "@react-sigma/core/lib/react-sigma.min.css";
import Main from "./components/layout/Main";
import SadAntLayout from "./containers/SadAntLayout";
import { Buffer } from 'buffer';
import { ReadableStream } from 'stream-browserify';
import { assert } from 'assert';
import LoginPage from "./pages/LoginPage"
import { configureAxios } from "./configureAxios";
import { PermissionProvider } from "./auth/permissions/PermissionProvider";

import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";


configureAxios();


const loading = (
	<div className="pt-3 text-center">
		<div className="sk-spinner sk-spinner-pulse"></div>
	</div>
);

export default function App() {
	window.rasekhVersion = '4.8.1'; // rVersion.data.rasekh;
	const account = useSelector((state) => state.account);
	axios.interceptors.request.use(function (config) {
		// const account = useSelector((state) => state.account);
		config.headers.Authorization = `${account.token}`;
		return config;
	});
	// useEffect(() => {
	// 	const getReqCount = () => {
	// 		axios
	// 			.get(NEW_API_SERVER() + "common/getVersion", {
	// 				headers: { Authorization: `${account.token}` },
	// 			})
	// 			.then((rVersion) => {
	// 				window.rasekhVersion = rVersion.data.rasekh;
	// 			});
	// 	};
	// 	getReqCount();
	// }, [account.token]);

	return (
		// <SadAntLayout>
		<Suspense fallback={loading}>
			<BrowserRouter basename={process.env.PUBLIC_URL}>
				<PermissionProvider>
					<Routes>
						<Route path="/login" element={<LoginPage />} />
						{renderRoutes(routes, Fragment, Fragment)}
					</Routes>
				</PermissionProvider>
			</BrowserRouter>
		</Suspense>
		// </SadAntLayout>
	);
}
